import httpClient from "@/api/httpClient.js";

const resource = "dashboard";

export function getDashboard() {
  return httpClient.get(`/${resource}` );
}
